export default __webpack_public_path__ + "static/media/connect.a132e882.svg";